import styled from 'styled-components';
import { color, fontFamily, fontSize, fontWeight, spacing } from 'theme';

export const StyledAccordion = styled.dl`
  border-bottom: 1px solid ${color('midnight_200')};
  margin: 0;
`;

export const StyledAccordionItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledSummary = styled.dt`
  border-top: 1px solid ${color('midnight_200')};
`;

export const StyledTitle = styled.div`
  margin: 0;
  font-family: ${fontFamily('sans')};
  font-size: ${fontSize('sm')};
  line-height: 1.142;
  font-weight: ${fontWeight('black')};
  display: flex;
  align-items: center;
  gap: ${spacing('md')};
`;

export const StyledTrigger = styled.button`
  -webkit-appearance: none;
  color: inherit;
  cursor: pointer;
  width: 100%;
  padding: ${spacing('xs')} 0;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  outline: none;
  text-align: left;

  &:focus-visible {
    ${StyledTitle}:before {
      color: ${color('active')};
    }
  }
`;

export const StyledTriggerIcon = styled.div`
  margin-left: auto;
  padding-left: ${spacing('md')};

  svg {
    width: ${spacing('sm')} !important;
    height: ${spacing('sm')};
    transition: transform 0.3s ease-in-out;

    .is-active & {
      transform: rotate(180deg);
      transform-origin: center center;
    }
  }
`;

export const StyledDetails = styled.dd`
  overflow: hidden;
  margin: 0;
  transition: max-height 0.3s ease-in-out;
`;

export const StyledContent = styled.div`
  padding-bottom: ${spacing('xs')};
  font-size: ${fontSize('sm')};

  p {
    margin: 0;
    &:not(:first-child) {
      margin-top: ${spacing('md')};
    }
  }

  ul,
  ol {
    margin-left: 1rem;
  }

  li {
    list-style-type: disc;
    margin: 0;
  }

  ol li {
    list-style-type: decimal;
  }

  img {
    display: block;
    margin-top: ${spacing('md')};
    margin-left: auto;
    margin-right: auto;

    &:not(:last-child) {
      margin-bottom: ${spacing('md')};
    }
  }

  figure {
    margin: 0;
  }

  figcaption {
    font-weight: ${fontWeight('extraBold')};
    color: ${color('text_subtle')};
    margin-top: ${spacing('sm')};
  }

  blockquote {
    margin: 0;
    font-style: italic;
  }

  .slick-track {
    display: flex;
    justify-content: center;
  }

  .slick-slide {
    margin-left: ${spacing('md')};
    margin-right: ${spacing('md')};

    &:first-child {
      margin-left: 0;
    }
  }

  .slick-dots {
    justify-content: flex-start;
  }
`;
